export class OrganizationAddress {

  addressId!: string;
  attentionLine!: string;
  addressLine1!: string;
  addressLine2!: string;
  addressLine3!: string;
  cityName!: string;
  stateCode!: string;
  postalCode!: string;
  countryCode!: string;
  typeCode!: string;
  typeDescription!: string;
  createTimestamp!: Date;
  createUser!: string;
  updateTimestamp!: Date;
  updateUser!: string;
  defaultShipTo!: boolean;
  defaultBillTo!: boolean;
  orgUnitId!: string;

}
